import { render, staticRenderFns } from "./CategoryLampView.vue?vue&type=template&id=1f6a390a&"
import script from "./CategoryLampView.vue?vue&type=script&lang=js&"
export * from "./CategoryLampView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports